<div class='sideBarContent content loading-spinner' *ngIf="isLoading"></div>
<div class="sideBarContent content" *ngIf="!isLoading">
  <irb-editor-sidebar-banner
  [accordian]="accordian"
  [showUnsavedChangesWarning]="showUnsavedChangesWarning"
  [isModified]="isModified"
  [isValid]="isValid"
  [hasPendingFunction]="hasPendingFunction"
  [slot]="slot"
  (save)="save()"
  (cancel)="cancel()"><span header class="ms-header" tooltip [tooltipTitle]="'Edit Portfolio'" [tooltipRequiresTruncation]="true">Edit Portfolio</span></irb-editor-sidebar-banner>
  <div class="body" [style.height]="bodyHeight" #body>
      <div class="block  status-message-model warning" *ngIf="data.isAutoRebalEnabled && selectedModel.allowAutoRebalOnModelUpdate === 'Paused for review'">
          <div style="padding-top:10px;">
              The assigned model has been changed by the model provider. Automated rebalancing will be paused until you review and resume rebalancing or assign this portfolio to a different model.
          </div>
          <div style="padding-top:10px;padding-bottom:10px;">
              <a class="nav-link-text" (click)="viewPortfolioModel()">Go to Model <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></a>
          </div>
      </div>
      <div class="block  status-message-model warning" *ngIf="data.isAutoRebalEnabled && selectedModel.allowAutoRebalOnModelUpdate === 'Not allowed'">
          <div style="padding-top:10px;">
              The assigned model does not currently allow automated rebalancing. You'll need to edit the model settings to allow automated rebalancing with this model.
          </div>
          <div style="padding-top:10px;padding-bottom:10px;">
              <a class="nav-link-text" (click)="viewPortfolioModel()">Go to Model <fa-icon [icon]="faChevronRight" class="chevron"></fa-icon></a>
          </div>
      </div>
      <div class="block editorDisplayBanner">
        <div class="left editorDispalybannerHeader" style="width: 255px">
          <div class="editorDispalybannerText">
            <p #portfolioName *ngIf="!isUnAuthorized">Portfolio Name | <strong><a id="editLink" (click)="showInlineEdit()">edit</a></strong></p>
            <p #portfolioName *ngIf="isUnAuthorized">Portfolio Name</p>
          </div>
          <span *ngIf="!showInLineeditFlag"
                class="editorDispalyValueText portfolio-name-truncate"
                tooltip
                [tooltipTitle]="data.portfolioName"
                [tooltipRequiresTruncation]="true"
                tooltipPosition="bottom">
                {{data.portfolioName}}
          </span>
          <irb-com-inlineedit *ngIf="showInLineeditFlag" [(tooltipMessage)]="tooltipMessage"
                              defaultTooltip="Please provide valid portfolio name."
                              [(data)]="data.portfolioName"
                              [maxlength]="70"
                              (save)="saveInlineEdit($event)"
                              (close)="closeInlineEdit()"
                              (change)="onTextChange()"
                              [allowSpecialCharacters]="false"
                              [customValidationFunction]="validatePortfolioName"
                              [customValidationOverride]="true"
                              ></irb-com-inlineedit>
          <!-- <input type="text" pInputText class="portfolioName" style="min-width: 230px"> -->
        </div>
        <div class="left editorDispalybannerHeader">
        <div class="editorDispalybannerText"><p #portfolioID>ID</p></div>
        <span class="editorDispalyValueText">{{data.portfolioId}}</span>
        </div>
        <div class="left editorDispalybannerHeader">
        <div class="editorDispalybannerText"><p #dateCreate>Date Created / By</p></div>
        <span  class="editorDispalyValueText" *ngIf="data.createdDate!=null">{{data.createdDate | easternTime | date:'MM/dd/yyyy h:mm a'}} ET</span>
        <div>{{data.createdBy}}</div>
        </div>
        <div class="left editorDispalybannerHeader">
        <div class="editorDispalybannerText"><p #lastEdit>Date Last Edited / By</p></div>
        <span *ngIf="data.modifiedDate!=null" class="editorDispalyValueText">{{data.modifiedDate | easternTime | date:'MM/dd/yyyy h:mm a'}} ET</span>
        <div>{{data.modifiedBy}}</div>
        </div>
        <div class="left editorDispalybannerHeader">
            <div  class="editorDispalybannerText"><p #mktValue>Market Value</p></div>
            <span class="editorDispalyValueText">{{data.totalPortfolioValue | currency:'USD'}}</span>
        </div>
        <br class="clear"/>
      </div>

      <div class="block editorDisplayBannerInfo" *ngIf="isUnAuthorized">
        <div class="editorDispalybannerText">Your User ID does not have access to all accounts assigned to this Portfolio.</div>
        <div class="editorDispalyValueText">
          If you wish to manage this Portfolio, you must remove the accounts not assigned to your User ID.
          <br>
          Please contact your FSA or iRebal support team to correct your user configuration at 855-640-2472.
        </div>
      </div>

      <mat-accordion #accordian="matAccordion" [multi]="true" >
          <mat-expansion-panel id="PORTFOLIO_HISTORY" [expanded]="localEditorsService.getDefaultExpansionState('PORTFOLIO_HISTORY')"
                               (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('PORTFOLIO_HISTORY','opened') : localEditorsService.updateExpansionState('PORTFOLIO_HISTORY','opened')"
                               (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('PORTFOLIO_HISTORY','closed') : localEditorsService.updateExpansionState('PORTFOLIO_HISTORY','closed')">
              <mat-expansion-panel-header>
                  <mat-panel-title>
                      Portfolio History
                  </mat-panel-title>
              </mat-expansion-panel-header>
              <ng-template matExpansionPanelContent>
                  <irb-com-portfolio-history [portfolioId]="portfolioId"></irb-com-portfolio-history>
              </ng-template>
          </mat-expansion-panel>
          <mat-expansion-panel id="ACCOUNTS" [expanded]="localEditorsService.getDefaultExpansionState('ACCOUNTS')"
          (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('ACCOUNTS','opened') : localEditorsService.updateExpansionState('ACCOUNTS','opened')"
          (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('ACCOUNTS','closed') : localEditorsService.updateExpansionState('ACCOUNTS','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Accounts
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent >
              <irb-com-accounts #assignedAccounts *ngIf="data && isGlobalSettings" [(data)]="data" [globalSettings]="globalSettings" (change)="onInputChange()"></irb-com-accounts>
            </ng-template>
          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="!isUnAuthorized" id="SETTINGS" [expanded]="localEditorsService.getDefaultExpansionState('SETTINGS')"
           (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('SETTINGS','opened') : localEditorsService.updateExpansionState('SETTINGS','opened')"
           (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('SETTINGS','closed') : localEditorsService.updateExpansionState('SETTINGS','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Model Assignments <img *ngIf="data.isAutoRebalEnabled && selectedModel?.allowAutoRebalOnModelUpdate === 'Paused for review'"
                  class="quick-icons" src="../../../assets/images/warning-icon-amber.svg" style="margin-left: 12px;">
              </mat-panel-title>
            </mat-expansion-panel-header>
              <irb-com-assignments *ngIf="data" [(data)]="data" [parentObj]="this"
              [selectedModel]="selectedModel"
              (selectedModelChange)="onSelectedModelChange($event)"
              (change)="onInputChange()"></irb-com-assignments>
          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="!isUnAuthorized" id="CUSTOM_LABELS" [expanded]="localEditorsService.getDefaultExpansionState('CUSTOM_LABELS')"
           (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('CUSTOM_LABELS','opened') : localEditorsService.updateExpansionState('CUSTOM_LABELS','opened')"
           (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('CUSTOM_LABELS','closed') : localEditorsService.updateExpansionState('CUSTOM_LABELS','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Custom Labels
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <irb-com-custom-labels *ngIf="data && isGlobalSettings" [(data)]="data" [globalSettings]="globalSettings" (change)="onInputChange()"></irb-com-custom-labels>
            </ng-template>
          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="!isUnAuthorized" id="SECURITY_RESTRICTIONS" [expanded]="localEditorsService.getDefaultExpansionState('SECURITY_RESTRICTIONS')"
          (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('SECURITY_RESTRICTIONS','opened') : localEditorsService.updateExpansionState('SECURITY_RESTRICTIONS','opened')"
          (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('SECURITY_RESTRICTIONS','closed') : localEditorsService.updateExpansionState('SECURITY_RESTRICTIONS','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Security Restrictions
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <irb-com-restrictions *ngIf="data && isGlobalSettings" [(data)]="data" [globalSettings]="globalSettings" [(isValid)]="isSecurityRestrictionsValid" (change)="onInputChange()"></irb-com-restrictions>
            </ng-template>
          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="isPortfEqvEnabled"  id="EQUIVALENTS_ALTERNATIVES" [expanded]="localEditorsService.getDefaultExpansionState('EQUIVALENTS_ALTERNATIVES')"
                               (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('EQUIVALENTS_ALTERNATIVES','opened') : localEditorsService.updateExpansionState('EQUIVALENTS_ALTERNATIVES','opened')"
                               (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('EQUIVALENTS_ALTERNATIVES','closed') : localEditorsService.updateExpansionState('EQUIVALENTS_ALTERNATIVES','closed')">
              <mat-expansion-panel-header>
                  <mat-panel-title>
                      Equivalents
                  </mat-panel-title>
              </mat-expansion-panel-header>
              <div *ngIf="!isUiTest">
                  <irb-portfolio-equivalents-alternatives *ngIf="data" [data]="data" (change)="onInputChange()"
                  (viewPortfolioModelOut)="viewPortfolioModel()"></irb-portfolio-equivalents-alternatives>
              </div>
          </mat-expansion-panel>

          <mat-expansion-panel *ngIf="!isUnAuthorized" id="GAINS_MANAGEMENT" [expanded]="localEditorsService.getDefaultExpansionState('GAINS_MANAGEMENT')"
          (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('GAINS_MANAGEMENT','opened') : localEditorsService.updateExpansionState('GAINS_MANAGEMENT','opened')"
          (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('GAINS_MANAGEMENT','closed') : localEditorsService.updateExpansionState('GAINS_MANAGEMENT','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Gains Management
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <irb-com-gains *ngIf="data && isGlobalSettings" [(data)]="data" [globalSettings]="globalSettings" [(isValid)]="isGainsManagementValid" (change)="onInputChange()"></irb-com-gains>
            </ng-template>
          </mat-expansion-panel>

        <mat-expansion-panel *ngIf="!isUnAuthorized  && isAutoRebalanceEnabled" id="AUTOMATED_REBALANCING" [expanded]="localEditorsService.getDefaultExpansionState('AUTOMATED_REBALANCING')"
                             (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('AUTOMATED_REBALANCING','opened') : localEditorsService.updateExpansionState('AUTOMATED_REBALANCING','opened')"
                             (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('AUTOMATED_REBALANCING','closed') : localEditorsService.updateExpansionState('AUTOMATED_REBALANCING','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Automated Rebalancing <img *ngIf="data.isAutoRebalEnabled && (selectedModel?.allowAutoRebalOnModelUpdate === 'Paused for review' || selectedModel?.allowAutoRebalOnModelUpdate === 'Not allowed')"
                class="quick-icons" src="../../../assets/images/warning-icon-amber.svg" style="margin-left: 12px;">
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <irb-com-automated-rebalancing *ngIf="data" [(data)]="data"
             [selectedModel]="selectedModel"
             [isTLHSetInGlobal]="isTLHSetInGlobal" (change)="onInputChange()"></irb-com-automated-rebalancing>
          </ng-template>
        </mat-expansion-panel>
        <mat-expansion-panel *ngIf="!isUnAuthorized" id="SCHEDULED_REBALANCES_LIST" [expanded]="localEditorsService.getDefaultExpansionState('SCHEDULED_REBALANCES_LIST')"
                             (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('SCHEDULED_REBALANCES_LIST','opened') : localEditorsService.updateExpansionState('SCHEDULED_REBALANCES_LIST','opened')"
                             (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('SCHEDULED_REBALANCES_LIST','closed') : localEditorsService.updateExpansionState('SCHEDULED_REBALANCES_LIST','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Scheduled Rebalances
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <irb-com-scheduled-rebalances-list *ngIf="data" [(data)]="data" (change)="onInputChange()"></irb-com-scheduled-rebalances-list>
          </ng-template>
        </mat-expansion-panel>
          <mat-expansion-panel *ngIf="!isUnAuthorized" id="PORTFOLIO_NOTES" [expanded]="localEditorsService.getDefaultExpansionState('PORTFOLIO_NOTES')"
          (opened)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('PORTFOLIO_NOTES','opened') : localEditorsService.updateExpansionState('PORTFOLIO_NOTES','opened')"
          (closed)="collapseForOpenTriggers? localEditorsService.updateExpansionStateOpenTriggers('PORTFOLIO_NOTES','closed') : localEditorsService.updateExpansionState('PORTFOLIO_NOTES','closed')">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Portfolio Notes
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <irb-com-portfolio-notes #listOfNotes *ngIf="data" [(data)]="data.listOfNotes" (change)="onInputChange()"></irb-com-portfolio-notes>
            </ng-template>
          </mat-expansion-panel>
      </mat-accordion>
  </div>
</div>
